var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-navigation-drawer",
    {
      class: [
        "navigation-drawer",
        "configuration-panel",
        { "is-portal": _vm.isPortalUser },
      ],
      attrs: {
        app: "",
        clipped: "",
        width: "250",
        permanent: "",
        temporary: _vm.$vuetify.breakpoint.mdAndUp ? false : true,
      },
    },
    [
      _c(
        "v-list",
        { staticClass: "pa-0", attrs: { dense: "" } },
        [
          _c(
            "button",
            {
              staticClass: "configuration-panel-button",
              on: { click: _vm.redirectConfigurationPanel },
            },
            [
              _c("span", { class: _vm.iconLeft }),
              _c("span", { staticClass: "text" }, [
                _vm._v(
                  _vm._s(_vm.$t("navigation.drawer-menu-items.config_panel"))
                ),
              ]),
            ]
          ),
          _vm._l(_vm.configurationMenu, function (item, index) {
            return [
              item.children.length
                ? _c(
                    "v-list-group",
                    {
                      key: `${item.text}-${index}`,
                      staticClass: "submenu-list",
                      attrs: {
                        value: _vm.isPortalUser
                          ? true
                          : _vm.checkIfOpened(item.text),
                        "append-icon": _vm.iconRight,
                        ripple: false,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function () {
                              return [
                                _c(
                                  "v-list-item",
                                  {
                                    staticClass: "header-submenu-text-item",
                                    attrs: { ripple: false },
                                  },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            staticClass: "list-item-title px-0",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.text.toUpperCase())
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _vm._l(item.children, function (child, index) {
                        return [
                          _c(
                            "v-list-item",
                            {
                              staticClass: "submenu-item",
                              attrs: {
                                to: `/${child.url}`,
                                target: child.target,
                                ripple: false,
                              },
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "list-item-title" },
                                    [_vm._v(_vm._s(child.text.toUpperCase()))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      }),
                    ],
                    2
                  )
                : _c(
                    "v-list-item",
                    {
                      key: `${item.text}-${index}`,
                      staticClass: "menu-item",
                      attrs: {
                        to: `/${item.url}`,
                        target: item.target,
                        ripple: false,
                        "active-class": "highlighted",
                      },
                    },
                    [
                      [
                        _c(
                          "v-list-item-content",
                          [
                            _c(
                              "v-list-item-title",
                              { staticClass: "list-item-title" },
                              [_vm._v(_vm._s(item.text.toUpperCase()))]
                            ),
                          ],
                          1
                        ),
                      ],
                    ],
                    2
                  ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }